import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {FlowChartDataService} from '../../../services/flow-chart-data.service';
import { MatSelectChange } from '@angular/material/select';

@Component({
    standalone: false,
    selector: 'particle-delete-section-dialog',
  templateUrl: './delete-section-dialog.component.html',
  styleUrls: ['./delete-section-dialog.component.scss']
})
export class DeleteSectionDialogComponent implements OnInit, IDialogView, AfterViewInit, OnDestroy {

  data: DialogModel;
  moveQuestionEnabled: boolean = false;
  sections: any[];
  selectedSection: any;

  constructor(private flowChartDataService: FlowChartDataService) {

  }

  ngOnInit() {
    if (this.data.input.moveSectionEnabled === true) {
      this.flowChartDataService.getFlowchartSectionsByFlowchartId().then(response => {
        this.sections = response.filter(section => section.id !== this.data.input.section.id);
      }, err => {
        console.error('get Flowchart Sections By FlowchartId error', err);
      });
      console.log(this.sections);
    }
  }

  ngAfterViewInit(): void {
  }

  onOkClicked(): boolean {

    if (this.moveQuestionEnabled) {
      this.data.input.destinationSection = this.selectedSection;
    }

    return true;
  }

  onSelectionChange($event: MatSelectChange) {
    this.selectedSection = $event.value;
  }

  moveQuestionEnabledToggle() {
    if (this.moveQuestionEnabled) {
      this.selectedSection = this.sections[0];
    } else {
      this.selectedSection = null;
    }
  }
  ngOnDestroy() {
    //this.flowChartDataService.destroy();
  }
}
